var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAirplaneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33709 10.6138L8.58235 9.57149C8.80061 9.50357 9.03459 9.50574 9.25141 9.57802C9.46823 9.65029 9.65677 9.78903 9.79043 9.97419L12.0171 13.5037L24.2401 7.41588C25.2038 6.85075 26.2795 6.50269 27.3916 6.39633C28.504 6.28998 29.6258 6.42775 30.6794 6.79999C31.7328 7.17199 32.6924 7.76975 33.4908 8.55121C34.2894 9.33292 34.9074 10.2792 35.3024 11.3244C35.4653 11.8521 35.4121 12.423 35.1545 12.9115C34.8968 13.4 34.4559 13.7664 33.9285 13.9301L25.8983 16.5358L25.0929 16.7963L23.5769 21.984C23.5307 22.1634 23.4388 22.3275 23.31 22.4604C23.1814 22.5931 23.0202 22.6903 22.8425 22.742L19.1946 23.9264C19.0031 24.0091 18.7926 24.0376 18.5862 24.0088C18.3795 23.9798 18.1849 23.8948 18.0235 23.7628C17.8622 23.6306 17.7402 23.4568 17.671 23.26C17.6017 23.0633 17.5879 22.8513 17.6312 22.6473L18.3892 18.9519L17.868 19.1178L10.0273 21.6524C9.774 21.7464 9.50449 21.7889 9.23449 21.7778C8.9645 21.7667 8.69934 21.7017 8.45472 21.5871C8.20986 21.4725 7.99039 21.3103 7.8091 21.11C7.62758 20.9098 7.48786 20.6754 7.39795 20.4206L4.65014 11.8929C4.57593 11.6323 4.6059 11.3529 4.73425 11.1141C4.86261 10.8753 5.0787 10.6959 5.33709 10.6138Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3972 33.6385H4.60278",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirplaneOutline);
export default __webpack_public_path__ + "static/media/icon_airplane_outline.a7c2526902eb364e62dd2515146497c7.svg";
export { ForwardRef as ReactComponent };